import { Children, type PropsWithChildren, type ReactNode } from 'react';

const BulletSeparated = ({ children }: PropsWithChildren) =>
  Children.toArray(children).flatMap((child: ReactNode, i, arr) =>
    arr.length > 1 && i < arr.length - 1
      ? [
          child,
          <span key={`bullet-${i}`} aria-hidden className="text-gray-600">
            {'\u2022 '}
          </span>,
        ]
      : [child],
  );

export default BulletSeparated;
